(function initCartGiftToggle() {
  if (window.cartGiftToggleInitialized) return;
  window.cartGiftToggleInitialized = true;

  const CART_ICON_BUBBLE_SECTION = "cart-icon-bubble";
  const CART_ITEMS_CONTAINER_ID = "main-cart-items";
  const CART_FOOTER_CONTAINER_ID = "main-cart-footer";
  const TOOLTIP_TRIGGER_SELECTOR = ".cart-gift-toggle__tooltip";
  const TOGGLE_CHECKBOX_CLASS = "cart-gift-toggle__checkbox";
  const TOGGLE_ROOT_SELECTOR = ".cart-gift-toggle";
  const POPUP_HIDE_GRACE_MS = 150;
  const DESKTOP_BREAKPOINT = 990;

  const readHandle = (attribute, fallback) => {
    const toggle = document.querySelector(TOGGLE_ROOT_SELECTOR);
    return (toggle && toggle.dataset[attribute]) || fallback;
  };
  const klydoclockHandle = () => readHandle("klydoclockHandle", "klydo-clock");
  const klydogreetHandle = () => readHandle("klydogreetHandle", "klydogreet");

  let isCartUpdateInFlight = false;
  let pendingBroadcast = null;
  let cartUpdateUnsubscriber = null;

  const getCartUpdateSectionIds = () => {
    const sectionIds = [];
    const cartItemsContainer = document.getElementById(CART_ITEMS_CONTAINER_ID);
    const cartFooterContainer = document.getElementById(
      CART_FOOTER_CONTAINER_ID,
    );
    if (cartItemsContainer && cartItemsContainer.dataset.id) {
      sectionIds.push(cartItemsContainer.dataset.id);
    }
    if (cartFooterContainer && cartFooterContainer.dataset.id) {
      sectionIds.push(cartFooterContainer.dataset.id);
    }
    sectionIds.push(CART_ICON_BUBBLE_SECTION);
    return sectionIds;
  };

  const swapInnerHtml = (liveElement, freshElement) => {
    if (liveElement && freshElement) {
      liveElement.innerHTML = freshElement.innerHTML;
    }
  };

  const applyCartSectionUpdates = (updatedSectionsByKey) => {
    if (!updatedSectionsByKey) return;
    const cartItemsContainer = document.getElementById(CART_ITEMS_CONTAINER_ID);
    const cartFooterContainer = document.getElementById(
      CART_FOOTER_CONTAINER_ID,
    );
    const cartItemsSectionId = cartItemsContainer
      ? cartItemsContainer.dataset.id
      : null;
    const cartFooterSectionId = cartFooterContainer
      ? cartFooterContainer.dataset.id
      : null;

    Object.entries(updatedSectionsByKey).forEach(
      ([sectionKey, renderedHtml]) => {
        const freshDom = new DOMParser().parseFromString(
          renderedHtml,
          "text/html",
        );

        if (sectionKey === cartItemsSectionId) {
          swapInnerHtml(
            cartItemsContainer.querySelector(".js-contents"),
            freshDom.querySelector(".js-contents"),
          );
          return;
        }

        if (sectionKey === cartFooterSectionId) {
          swapInnerHtml(
            cartFooterContainer.querySelector(".js-contents-total"),
            freshDom.querySelector(".js-contents-total"),
          );
          return;
        }

        if (sectionKey === CART_ICON_BUBBLE_SECTION) {
          swapInnerHtml(
            document.getElementById("cart-icon-bubble"),
            freshDom.querySelector(".shopify-section"),
          );
        }
      },
    );
  };

  const getKlydogreetVariantId = () =>
    document.querySelector("." + TOGGLE_CHECKBOX_CLASS)?.dataset.variantId ||
    null;

  const postCartUpdate = async (endpoint, quantity, variantId) => {
    if (isCartUpdateInFlight) return null;
    isCartUpdateInFlight = true;
    try {
      const requestBody = new FormData();
      requestBody.append("id", variantId);
      requestBody.append("quantity", String(quantity));
      requestBody.append("sections", getCartUpdateSectionIds().join(","));
      requestBody.append("sections_url", window.location.pathname);

      const response = await fetch(endpoint, {
        method: "POST",
        body: requestBody,
      });

      if (!response.ok) {
        const errorBody = await response.text().catch(() => "");
        throw new Error(
          `${endpoint} failed (${response.status}): ${errorBody.slice(0, 200)}`,
        );
      }

      const responseData = await response.json();

      applyCartSectionUpdates(responseData.sections);

      const isCartEmpty = responseData.item_count === 0;
      document
        .querySelector("cart-items")
        ?.classList.toggle("is-empty", isCartEmpty);
      document
        .getElementById(CART_FOOTER_CONTAINER_ID)
        ?.classList.toggle("is-empty", isCartEmpty);

      portalAllTooltipPopups();
      pendingBroadcast = responseData;
      return responseData;
    } finally {
      isCartUpdateInFlight = false;
      // Published only once the guard is clear, so anything the subscribers
      // trigger — the orphan cleanup above all — is not refused as re-entrant.
      if (pendingBroadcast) {
        const broadcast = pendingBroadcast;
        pendingBroadcast = null;
        if (document.querySelector("cart-drawer")) publishCartUpdate(broadcast);
      }
    }
  };

  // Source deliberately isn't "cart-items", so `CartDrawerItems.onCartUpdate`
  // picks it up and re-fetches the drawer.
  const publishCartUpdate = (cartData) => {
    try {
      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-gift-toggle",
          cartData,
        });
      }
    } catch (error) {
      console.warn("[cart-gift-toggle] cartUpdate subscriber error", error);
    }
  };

  const addKlydogreetToCart = (variantId) =>
    postCartUpdate("/cart/add.js", 1, variantId);
  const removeKlydogreetFromCart = (variantId) =>
    postCartUpdate("/cart/change.js", 0, variantId);

  const handleToggleChange = async (changeEvent, checkbox) => {
    changeEvent.stopPropagation();

    const variantId = checkbox.dataset.variantId;
    if (!variantId) return;

    const wasChecked = checkbox.checked;
    checkbox.disabled = true;

    try {
      const result = await (wasChecked
        ? addKlydogreetToCart(variantId)
        : removeKlydogreetFromCart(variantId));
      if (result === null) checkbox.checked = !wasChecked;
    } catch (error) {
      console.error("[cart-gift-toggle]", error);
      checkbox.checked = !wasChecked;
      showToggleError(window.cartStrings.giftToggleError, checkbox);
    } finally {
      checkbox.disabled = false;
      cleanupWhenKlydoclockGone();
    }
  };

  const showToggleError = (message, checkbox) => {
    const isInDrawer = Boolean(checkbox && checkbox.closest("cart-drawer"));
    const errorEl = isInDrawer
      ? document.getElementById("CartDrawer-CartErrors")
      : document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
    if (!errorEl) return;
    errorEl.textContent = message;
    clearTimeout(showToggleError._timer);
    showToggleError._timer = setTimeout(() => {
      errorEl.textContent = "";
    }, 4000);
  };

  const hideToggleNow = () => {
    document
      .querySelectorAll(TOGGLE_ROOT_SELECTOR)
      .forEach((toggle) => toggle.classList.add("is-hidden"));
  };

  // `item_count` is what separates a cart from an add response: /cart/add.js
  // answers with an `items` array too, but it holds only what was just added,
  // so reading it as the cart would look like everything else had gone.
  const isCartSnapshot = (value) =>
    Boolean(value) &&
    Array.isArray(value.items) &&
    typeof value.item_count === "number";

  const cleanupWhenKlydoclockGone = async (cartSnapshot) => {
    if (!isCartSnapshot(cartSnapshot)) {
      try {
        const response = await fetch("/cart.js");
        cartSnapshot = await response.json();
      } catch (error) {
        console.warn(
          "[cart-gift-toggle] failed to fetch /cart.js snapshot:",
          error,
        );
        return;
      }
    }

    const stillHasKlydoclock = cartSnapshot.items.some(
      (item) => item.handle === klydoclockHandle(),
    );
    if (stillHasKlydoclock) return;

    hideToggleNow();

    // Taken from the cart, not from the checkbox: by the time the last
    // Klydoclock is gone the toggle is no longer rendered, so reading the
    // variant off it found nothing and the Klydogreet was left stranded — a
    // free line on its own, which the cart is never meant to hold. The line key
    // is used in preference to the variant id so a duplicate variant can't
    // match the wrong line.
    const leftoverKlydogreet = cartSnapshot.items.find(
      (item) => item.handle === klydogreetHandle(),
    );
    if (leftoverKlydogreet) {
      const lineId =
        leftoverKlydogreet.key ||
        leftoverKlydogreet.variant_id ||
        getKlydogreetVariantId();
      if (lineId) {
        try {
          await removeKlydogreetFromCart(lineId);
        } catch (error) {
          console.error(
            "[cart-gift-toggle] removing leftover Klydogreet failed:",
            error,
          );
        }
      }
    }

    document
      .querySelectorAll(TOGGLE_ROOT_SELECTOR)
      .forEach((toggle) => toggle.remove());
  };

  const portaledTooltipPairs = [];

  const removeOrphanPortaledPopups = () => {
    for (let index = portaledTooltipPairs.length - 1; index >= 0; index--) {
      const pair = portaledTooltipPairs[index];
      if (pair.trigger.isConnected) continue;

      pair.documentListeners.forEach(({ type, listener }) => {
        document.removeEventListener(type, listener);
      });
      pair.popup.remove();
      portaledTooltipPairs.splice(index, 1);
    }
  };

  const portalTooltipPopup = (tooltipTrigger) => {
    const popupElement = tooltipTrigger.querySelector(
      ".klydogreet-info__popup",
    );
    if (!popupElement || popupElement.dataset.portaled === "true") return;

    popupElement.dataset.portaled = "true";
    document.body.appendChild(popupElement);
    const documentListeners = [];
    portaledTooltipPairs.push({
      trigger: tooltipTrigger,
      popup: popupElement,
      documentListeners,
    });

    let hideTimer = null;
    const isOpen = () => popupElement.style.display === "flex";
    const POPUP_TRIGGER_GAP = 8;
    const POPUP_VIEWPORT_EDGE = 8;
    const POPUP_CENTER_BREAKPOINT = 550;
    const positionPopupNearTrigger = () => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const popupRect = popupElement.getBoundingClientRect();

      if (viewportWidth < POPUP_CENTER_BREAKPOINT) {
        popupElement.style.left = (viewportWidth - popupRect.width) / 2 + "px";
        popupElement.style.top = (viewportHeight - popupRect.height) / 2 + "px";
        return;
      }

      const triggerRect = tooltipTrigger.getBoundingClientRect();
      let popupLeft = triggerRect.right + POPUP_TRIGGER_GAP;
      if (popupLeft + popupRect.width > viewportWidth - POPUP_VIEWPORT_EDGE) {
        popupLeft = triggerRect.left - popupRect.width - POPUP_TRIGGER_GAP;
      }
      if (popupLeft < POPUP_VIEWPORT_EDGE) {
        popupLeft = POPUP_VIEWPORT_EDGE;
      }

      let popupTop =
        triggerRect.top + triggerRect.height / 2 - popupRect.height / 2;
      if (popupTop < POPUP_VIEWPORT_EDGE) {
        popupTop = POPUP_VIEWPORT_EDGE;
      }
      if (popupTop + popupRect.height > viewportHeight - POPUP_VIEWPORT_EDGE) {
        popupTop = viewportHeight - popupRect.height - POPUP_VIEWPORT_EDGE;
      }

      popupElement.style.left = popupLeft + "px";
      popupElement.style.top = popupTop + "px";
    };
    const showPopup = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      popupElement.style.display = "flex";
      positionPopupNearTrigger();
      tooltipTrigger.setAttribute("aria-expanded", "true");
    };
    const queueHide = () => {
      if (window.innerWidth < DESKTOP_BREAKPOINT) return;
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        popupElement.style.display = "none";
        tooltipTrigger.setAttribute("aria-expanded", "false");
        hideTimer = null;
      }, POPUP_HIDE_GRACE_MS);
    };
    const hidePopupNow = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      popupElement.style.display = "none";
      tooltipTrigger.setAttribute("aria-expanded", "false");
    };

    tooltipTrigger.addEventListener("mouseenter", showPopup);
    tooltipTrigger.addEventListener("mouseleave", queueHide);
    tooltipTrigger.addEventListener("focusin", showPopup);
    tooltipTrigger.addEventListener("focusout", queueHide);
    popupElement.addEventListener("mouseenter", showPopup);
    popupElement.addEventListener("mouseleave", queueHide);

    tooltipTrigger.addEventListener("click", (event) => {
      event.stopPropagation();
      showPopup();
    });

    const closeButton = popupElement.querySelector(
      ".klydogreet-info__popup-close",
    );
    closeButton?.addEventListener("click", (event) => {
      event.stopPropagation();
      hidePopupNow();
    });

    const closeOnOutsideClick = (event) => {
      if (!isOpen()) return;
      if (
        tooltipTrigger.contains(event.target) ||
        popupElement.contains(event.target)
      )
        return;
      hidePopupNow();
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape" && isOpen()) hidePopupNow();
    };

    document.addEventListener("click", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    documentListeners.push(
      { type: "click", listener: closeOnOutsideClick },
      { type: "keydown", listener: closeOnEscape },
    );
  };

  const portalAllTooltipPopups = () => {
    removeOrphanPortaledPopups();
    document
      .querySelectorAll(TOOLTIP_TRIGGER_SELECTOR)
      .forEach(portalTooltipPopup);
  };

  // The drawer re-renders its body from a fetch, which finishes after every
  // `portalAllTooltipPopups` call above has already run — leaving the fresh "?"
  // button with its popup still nested inside it and no listeners bound, so
  // clicking it did nothing. Re-portalling on the mutation covers all of the
  // drawer's render paths without each of them having to know about tooltips.
  const rePortalOnDrawerRerender = () => {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof MutationObserver === "undefined") return;

    let isRePortalScheduled = false;
    const observer = new MutationObserver(() => {
      if (isRePortalScheduled) return;
      isRePortalScheduled = true;
      // Portalling moves nodes, which re-triggers this — the flag plus the
      // `portaled` marker make the follow-up pass a no-op.
      requestAnimationFrame(() => {
        isRePortalScheduled = false;
        portalAllTooltipPopups();
      });
    });

    observer.observe(drawer, { childList: true, subtree: true });
  };

  const subscribeToCartUpdates = () => {
    if (
      typeof subscribe !== "function" ||
      typeof PUB_SUB_EVENTS === "undefined"
    )
      return;
    // `publish` runs subscribers unguarded, and product-form publishes before it
    // renders the cart — so anything thrown in here would abort the add-to-cart
    // rather than just fail this handler.
    cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      try {
        handleCartUpdate(event);
      } catch (error) {
        console.error("[cart-gift-toggle] cartUpdate handler failed:", error);
      }
    });
  };

  const handleCartUpdate = (event) => {
    const eventCart = event && event.cartData;
    if (
      isCartSnapshot(eventCart) &&
      !eventCart.items.some((item) => item.handle === klydoclockHandle())
    ) {
      hideToggleNow();
      // Only the cart page's row: the drawer re-renders itself from Liquid
      // once the line is actually gone, and removing its row here just left
      // the heading's count and the subtotal describing a line still in the
      // cart.
      document
        .querySelectorAll(
          'tr.cart-item[data-product-handle="' + klydogreetHandle() + '"]',
        )
        .forEach((row) => row.remove());
    }
    syncToggleCheckboxes(eventCart);
    cleanupWhenKlydoclockGone(eventCart);
    portalAllTooltipPopups();
  };

  // The cart page's toggle sits outside the region the section swap replaces,
  // so ticking the gift in the drawer left it unchecked — and clicking it then
  // added a second Klydogreet.
  const syncToggleCheckboxes = (cartSnapshot) => {
    if (!isCartSnapshot(cartSnapshot)) return;
    const hasKlydogreet = cartSnapshot.items.some(
      (item) => item.handle === klydogreetHandle(),
    );
    document.querySelectorAll("." + TOGGLE_CHECKBOX_CLASS).forEach((checkbox) => {
      checkbox.checked = hasKlydogreet;
    });
  };

  const initialize = () => {
    document.addEventListener("change", (event) => {
      const checkbox = event.target.closest
        ? event.target.closest("." + TOGGLE_CHECKBOX_CLASS)
        : null;
      if (checkbox) handleToggleChange(event, checkbox);
    });
    subscribeToCartUpdates();
    portalAllTooltipPopups();
    rePortalOnDrawerRerender();
    window.addEventListener("pagehide", () => {
      if (typeof cartUpdateUnsubscriber === "function")
        cartUpdateUnsubscriber();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
